export default __webpack_public_path__ + "static/media/priyanka-kapale.fa05e009.jpeg";